import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Field, Input, Checkbox, SubmitButton, ErrorBanner, CommonIdentityFields
} from "@/components/auth/FormPrimitives";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/utils/api";
import { consumePostAuthRedirect } from "@/utils/postAuthRedirect";

export default function ParentSignupForm() {
  const { signup } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({
    full_name: "", email: "", phone: "", password: "",
    country: "India", timezone: "Asia/Kolkata", relationship: "Father",
    accept_terms: false, accept_privacy: false, accept_medical_disclaimer: false,
  });
  const set = (k, v) => setValues((p) => ({ ...p, [k]: v }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await signup("parent", values);
      navigate(consumePostAuthRedirect(), { replace: true });
    } catch (e2) {
      setError(formatApiError(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={onSubmit} className="space-y-4" data-testid="parent-signup-form">
      <CommonIdentityFields values={values} onChange={set} testidPrefix="parent-signup" />

      <Field label="Relationship to child(ren)" required htmlFor="parent-signup-relationship">
        <Input
          id="parent-signup-relationship"
          testid="parent-signup-relationship"
          required
          value={values.relationship}
          onChange={(e) => set("relationship", e.target.value)}
          placeholder="Father / Mother / Guardian"
        />
      </Field>

      <div className="pt-2 space-y-2">
        <Checkbox
          testid="parent-accept-terms"
          checked={values.accept_terms}
          onChange={(e) => set("accept_terms", e.target.checked)}
        >
          I agree to the <a href="/terms" target="_blank" className="text-sky-400 hover:underline">Terms of Service</a>
        </Checkbox>
        <Checkbox
          testid="parent-accept-privacy"
          checked={values.accept_privacy}
          onChange={(e) => set("accept_privacy", e.target.checked)}
        >
          I have read the <a href="/privacy" target="_blank" className="text-sky-400 hover:underline">Privacy Policy</a>
        </Checkbox>
        <Checkbox
          testid="parent-accept-disclaimer"
          checked={values.accept_medical_disclaimer}
          onChange={(e) => set("accept_medical_disclaimer", e.target.checked)}
        >
          I acknowledge the <a href="/medical-disclaimer" target="_blank" className="text-sky-400 hover:underline">Medical Disclaimer</a> — tots360 reports are informational, not a substitute for professional medical advice.
        </Checkbox>
      </div>

      <ErrorBanner error={error} />
      <SubmitButton loading={loading} testid="parent-signup-submit">Create Parent account</SubmitButton>
    </form>
  );
}
